export default __webpack_public_path__ + "static/media/new-ward-street-garage-rendering1.f64e3058.png";